import React, { Component } from 'react'
import { Alert, Col, Modal, Row, Tabs } from 'antd'
import LeavesForm from './LeavesForm'
import LeaveBalance from './LeaveBalance'
import Documents from '../../Common/Documents/DocumentsCont'
import { numVal } from '../../../modules/Utils'
import FooterButton from '../../../elements/Buttons/FooterButtons'

const { TabPane } = Tabs

class LeaveModal extends Component {
  render() {
    const {
      type,
      visible,
      leave,
      onCancel,
      submitting,
      submit,
      update,
      removing,
      remove,
      fetchingLeave,
      formRef,
      currentLeaveCode,
      onChangeEmployee,
      balance,
    } = this.props

    let mgs,
      mgsInfo = 'info'
    switch (currentLeaveCode) {
      case 'AL':
        const inLieu = balance.find((a) => a.code === 'LL') || {}
        const available = numVal(inLieu, 'entitled') - numVal(inLieu, 'taken')
        if (available > 0) {
          mgs = `You Have ${available} Available (In Lieu) days, This action will used from it's balance `
          mgsInfo = 'info'
        }
        break
      case 'LL':
        mgs = 'The Days will be added to your In Lieu balance'
        mgsInfo = 'success'
        break
      default:
        mgs = ''
    }

    const isEdit = type === 'edit'
    const isNew = type !== 'edit'

    return (
      <Modal
        title={type !== 'edit' ? 'Apply for leave' : 'Update Leave'}
        destroyOnClose={true}
        visible={visible}
        onCancel={onCancel}
        width={type === 'edit' ? 900 : '95%'}
        footer={
          <FooterButton
            type={type}
            status={leave.status}
            remove={remove}
            removing={removing}
            submit={submit}
            submitting={submitting}
            update={update}
            title={'Leave'}
            isEdit={type === 'edit'}
            isNew={type === 'new'}
            visible={type === 'new' || leave.status === 'Submitted' || leave.status === 'Draft'}
          />
        }>
        <Tabs defaultActiveKey="form">
          <TabPane tab="Form" key="form">
            <Row>
              {type !== 'edit' && (
                <Col span={10}>
                  <LeaveBalance {...this.props} />
                  {mgs && <Alert message={mgs} type={mgsInfo} showIcon style={{ marginTop: '10px' }} />}
                </Col>
              )}
              <Col offset={isEdit ? 0 : 2} span={isEdit ? 24 : 10}>
                <LeavesForm
                  ref={formRef}
                  loading={fetchingLeave}
                  onChangeEmployee={onChangeEmployee}
                  leave={leave}
                  {...this.props}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane disabled={isNew} tab="Files" key="files">
            <Documents editable={leave.status === 'Submitted'} footer={false} category={false} owner={leave} />
          </TabPane>
        </Tabs>
      </Modal>
    )
  }
}

LeaveModal.propTypes = {}
LeaveModal.defaultProps = {}

export default LeaveModal
